// import React from 'react'
import { AlertTriangle, Clock, X } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

interface SessionWarningProps {
  message: string
  timeRemaining: number
  onExtend: () => void
  onDismiss: () => void
}

export function SessionWarning({ message, timeRemaining, onExtend, onDismiss }: SessionWarningProps) {
  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
  }

  return (
    <Alert className="border-orange-200 bg-orange-50">
      <AlertTriangle className="h-4 w-4 text-orange-600" />
      <AlertDescription className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Clock className="h-4 w-4 text-orange-600" />
          <span className="text-orange-800">
            {message} (Expires in {formatTime(timeRemaining)})
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onExtend}
            className="text-orange-700 border-orange-300 hover:bg-orange-100"
          >
            Stay Logged In
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            className="text-orange-600 hover:bg-orange-100"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </AlertDescription>
    </Alert>
  )
}
